import { render, staticRenderFns } from "./GridImageProviderUser.vue?vue&type=template&id=71804a61&"
import script from "./GridImageProviderUser.vue?vue&type=script&lang=js&"
export * from "./GridImageProviderUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports